module.exports = __webpack_public_path__ + "media/images/payments/clickandbuy-dark-c3b2edf4992833159409eeefa21671a9.svg";